import * as React from "react";
import type { SVGProps } from "react";
const SvgImageCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M5.8 21.6 16 12l4.8 4.8m-15 4.8h12a3.6 3.6 0 0 0 3.6-3.6V9.6m-15.6 12A3.6 3.6 0 0 1 2.2 18V6a3.6 3.6 0 0 1 3.6-3.6h9m1 3 1.8 1.8L21.8 3M9.4 7.8a1.8 1.8 0 1 1-3.6 0 1.8 1.8 0 0 1 3.6 0"
    />
  </svg>
);
export default SvgImageCheck;
